//This templeates initial purpose was to serve as a place to quickly copy and pase
//a style function file that follows this projects design pattern

import React, {useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';

function Styles() {
	//#region Params
	let isMobile = useContext(GlobalContext).isMobile;
	let size = useContext(GlobalContext).size;
	let minimumMarginX = useContext(GlobalContext).minimumMargin;
	let outerStyleFlexDirection = 'column';
	//#endregion

	//#region Style vars
	let titleFontSize = '4rem';
	let descGenericTextFontSize = '1rem';
	//#endregion

	//#region seting vars based off params
	if (size === 'lg') {
	} else if (size === 'md') {
	} else if (size === 'sm') {
		descGenericTextFontSize = '0.75rem';
	}
	if (isMobile) {
		titleFontSize = '3rem';
		outerStyleFlexDirection = 'row';
	}
	//#endregion

	return {
		outerStyle: () => {
			return {
				display: 'flex',
				flexDirection: outerStyleFlexDirection,
				height: 'auto',
				padding: `3rem ${minimumMarginX}rem`,
				flexWrap: 'wrap',
			};
		},
		titleStyle: () => {
			return {
				textAlign: 'center',
				color: 'black',
				width: '100%',
				fontSize: titleFontSize,
			};
		},
		decRoundContainerStyle: () => {
			return {
				marginTop: '1rem',
				display: 'flex',
				padding: `0 0 1rem 1rem`,
				width: '100%',
				border: '1px solid rgba(38, 38, 38, 0.2)',
				borderRadius: '10px',
				height: 'auto',
				boxShadow: `4px 4px 16px rgba(150, 150, 150, 0.4)`,
			};
		},
		decRoundCollumnStyle: ({entries, isNumber, hasNumber} = {}) => {
			let style = {
				padding: '1rem 1rem 0 0',
				display: 'flex',
				flexWrap: 'wrap',
				height: '100%',
			};
			let width = '10%';
			if (entries === 5) {
				if (isNumber) {
					width = '10%';
					style.margin = 'auto 0';
				} else {
					if (hasNumber) {
						width = `${90 / 4}%`;
					} else {
						width = `${100 / 4}%`;
					}
				}
				style.width = width;
			}

			return style;
		},
		descRoundCollumnClasses: ({entries} = {}) => {
			let classes = '';

			if (entries !== 5) {
				let colAnount = 12 / entries;
				classes += `col-${colAnount}`;
			}

			return classes;
		},
		descGenericText: ({isNumber, isHeader}) => {
			let style = {
				width: '100%',
				height: '50%',
				margin: '0 0',
				fontSize: descGenericTextFontSize,
			};

			if (isNumber) {
				style.fontWeight = '700';
				style.fontSize = '2rem';
				style.margin = 'auto';
			}
			if (isHeader) {
				style.fontWeight = '700';
			} else {
				if (!isNumber) {
					style.marginTop = '1rem';
				}
			}

			return style;
		},

		mobRoundContainerStyle: ({isEven} = {}) => {
			let marginLeft = isEven ? 0 : '0.5rem';
			let marginRight = !isEven ? 0 : '0.5rem';

			return {
				display: 'felx',
				height: 'auto',
				padding: `1rem ${marginRight} 0 ${marginLeft}`,
			};
		},
		mobRoundContainerClasses: () => {
			let classes = 'col-6';
			return classes;
		},
		mobBorderMaker: () => {
			return {
				height: '100%',
				display: 'flex',
				border: '1px solid rgba(38, 38, 38, 0.2)',
				flexDirection: `column`,
				padding: `0 1rem 1rem 1rem`,
				borderRadius: '10px',
				boxShadow: `4px 4px 16px rgba(150, 150, 150, 0.4)`,
			};
		},
		mobGenericText: ({isNumber, isHeader}) => {
			let marginTop = '0.5rem';
			let fontWeight = '400';
			let fontSize = '1rem';
			if (isHeader) {
				marginTop = '1rem';
				fontWeight = '700';
			}
			if (isNumber) {
				fontSize = '1.5rem';
			}
			return {
				width: '100%',
				margin: `${marginTop} 0 0 0`,
				fontSize: fontSize,
				fontWeight: fontWeight,
			};
		},
	};
}

export default Styles;
